import React, { useState } from "react";

import EventNavigation from "../EventNavigation/EventNavigation";
import Form from "../Form/Form";
import Footer from "../Footer/Footer";
import "./memberships_page.css";

const membershipTiers = [
  {
    name: "Industry Circle",
    tag: "Limited Seats",
    price: "PKR 15,000",
    positioning: "Be part of the foundation",
    objective:
      "Build the core of the ecosystem with early members who shape its direction and identity.",
    access:
      "Entry into a curated network, lifetime rate lock, and access to events, content, and deal flow.",
    audience:
      "Developers, senior brokers, architects, and PropTech founders entering the ecosystem.",
    benefits: [
      "Limited to 50 members",
      "Founding member pricing locked",
      "Access to all official events",
      "Digital Founding Member badge",
      "Full ecosystem app access",
    ],
    cta: "Apply as Founding Member",
  },
  {
    name: "Founding Member",
    tag: "Most Preferred",
    price: "PKR 30,000",
    positioning: "Move from access to participation",
    objective:
      "Deepen engagement by turning members into active contributors and deal-flow participants.",
    access:
      "Structured upgrade within the ecosystem, exclusive rooms, curated interactions, plus access to deal alerts and member spotlight.",
    audience:
      "Active members, institutional investors, and decision-makers seeking deeper involvement.",
    benefits: [
      "Priority deal-flow alerts",
      "Closed-door curated rooms",
      "Member spotlight feature",
      "Podcast guest eligibility",
      "Preferred positioning at events",
    ],
    cta: "Apply for Industry Circle",
    recommended: true,
  },
  {
    name: "Corporate Partner",
    tag: "By Invitation",
    price: "PKR 300,000",
    positioning: "Lead the ecosystem",
    objective:
      "Enable institutions to drive visibility, partnerships, and revenue within the ecosystem.",
    access:
      "Full brand integration across platforms with direct access to high-value stakeholders across content, events, and digital channels.",
    audience:
      "Financial institutions, Tier 1 developers, private equity firms, and PropTech companies.",
    benefits: [
      "Brand integration across content and events",
      "Magazine and podcast sponsorship",
      "Curated developer introductions",
      "Executive-level positioning",
      "Maximum ecosystem visibility",
    ],
    cta: "Apply as Strategic Partner",
  },
];

const MembershipsPage = () => {
  const [selectedTier, setSelectedTier] = useState("Industry Circle");

  const handleTierSelect = (tierName) => {
    setSelectedTier(tierName);

    const formSection = document.getElementById("form_section");
    if (formSection) {
      formSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      <EventNavigation />

      <main id="memberships_page_main">
        <section id="memberships_page_intro">
          <div id="memberships_page_intro_inner">
            <p id="memberships_page_intro_eyebrow">Choose Your Level Of Access</p>
            <h1 id="memberships_page_intro_hdng">Membership Tiers</h1>
            {/* <p id="memberships_page_intro_txt">
              Three levels of access, based on your role and intent within the ecosystem.
            </p> */}
          </div>
        </section>

        <section id="membership_tiers_section">
          <div id="membership_tiers_grid">
            {membershipTiers.map((tier) => (
              <article
                className={`membership_tier_card${tier.recommended ? " membership_tier_card_featured" : ""}`}
                key={tier.name}
              >
                <div className="membership_tier_card_top">
                  <span className="membership_tier_tag">{tier.tag}</span>
                  <h2 className="membership_tier_name">{tier.name}</h2>
                  <p className="membership_tier_price">{tier.price}</p>
                  <p className="membership_tier_positioning">{tier.positioning}</p>
                </div>

                <div className="membership_tier_body">
                  {/* <div className="membership_tier_meta">
                    <p className="membership_tier_meta_label">Objective</p>
                    <p className="membership_tier_meta_text">{tier.objective}</p>
                  </div> */}
                  <div className="membership_tier_meta">
                    {/* <p className="membership_tier_meta_label">Access</p> */}
                    <p className="membership_tier_meta_text">{tier.access}</p>
                  </div>
                  {/* <div className="membership_tier_meta">
                    <p className="membership_tier_meta_label">Who It&apos;s For</p>
                    <p className="membership_tier_meta_text">{tier.audience}</p>
                  </div> */}

                  <div className="membership_tier_benefits">
                    {/* <p className="membership_tier_benefits_hdng">Benefits</p> */}
                    <ul className="membership_tier_benefits_list">
                      {tier.benefits.map((benefit) => (
                        <li key={benefit}>{benefit}</li>
                      ))}
                    </ul>
                  </div>
                </div>

                <button
                  className="membership_tier_btn"
                  type="button"
                  onClick={() => handleTierSelect(tier.name)}
                >
                  {tier.cta}
                </button>
              </article>
            ))}
          </div>
        </section>

        <Form selectedTier={selectedTier} />
      </main>

      <Footer />
    </>
  );
};

export default MembershipsPage;
